import { API_BASE_URL } from "../config";
import { handleRequest } from "../utilities/requestHandler";

export const askChatbot = (req_body) => 
    handleRequest("post", "/chip/chat", req_body);

export const clearChatbotSession = (req_body) =>
    handleRequest("post", "/chip/clear", req_body);

export const getChatbotStatus = () =>
    handleRequest("get", "/chip/status");

export const submitChatbotFeedback = (req_body) =>
    handleRequest("post", "/chip/feedback", req_body);

export const streamChatbot = async (reqBody, { onEvent, signal } = {}) => {
    const token = localStorage.getItem("token");
    const baseUrl = (API_BASE_URL || "http://localhost:5000").replace(/\/$/, "");
    const response = await fetch(`${baseUrl}/chip/stream`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(reqBody || {}),
        signal,
    });

    if (!response.ok) {
        throw new Error(`CHIP stream failed (${response.status})`);
    }

    const reader = response.body?.getReader?.();
    if (!reader) {
        throw new Error("CHIP stream unavailable");
    }

    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    let sawDone = false;

    while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split("\n\n");
        buffer = parts.pop() || "";

        for (const part of parts) {
            const line = part.trim();
            if (!line.startsWith("data:")) continue;
            const payload = line.replace(/^data:\s*/, "");
            if (!payload) continue;
            try {
                const parsed = JSON.parse(payload);
                if (parsed?.type === "done") {
                    sawDone = true;
                }
                if (onEvent) onEvent(parsed);
            } catch (_error) {
                // ignore malformed payload
            }
        }
    }

    if (!sawDone && onEvent) {
        onEvent({ type: "done" });
    }
};
